<template>
    <div>
        <div class="intro-screen">
            <div class="container">
                <div class="wrap-intro" :class="{'loggedin': hasSession}">
                    <intro-form v-if="!hasSession" @loggedin="onLogin"></intro-form>
                    <transition name="slide"
                        enter-active-class="fadeIn"
                        leave-active-class="fadeOut">
                        <dashboard v-if="hasSession"></dashboard>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IntroForm from '../forms/IntroForm.vue';
    import Dashboard from './Dashboard.vue';

    export default {
        name: 'LandingPage',
        components: {
            IntroForm,
            Dashboard
        },
        data: function () {
            return {
                 data_type: process.env.DATA,
                 hasSession: false,
                 loaded: false
            }
        },
        filters: {
            capitalise: function (value) {
                if (!value) return '';
                value = value.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            },
            uppercase: function(value) {
                if (!value) return '';
                value = value.toString();
                return value.toUpperCase();
            }
        },
        computed: {
            data_type_cap: function(){
                return this.data_type.charAt(0).toUpperCase() + this.data_type.slice(1);
            }
        },
        created: function() {
            this.hasSession = this.$store.getters.hasAccessToken;
        },
        methods: {
            onLogin: function(ev) {
                if (ev == true) {
                    this.hasSession = true;
                    this.$emit('headerChange', true);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/LandingPage.vue